const setThreadWebSearchState = ({ threadId, status, callsCompleted, maxCalls } = {}) => {
  return {
    type: 'pieveSetThreadWebSearchState',
    payload: { threadId, status, callsCompleted, maxCalls }
  };
};

export default setThreadWebSearchState;
